import { Link } from "gatsby";
import React from "react";

/**
 * Renders an <li> element containing either an external <a> hyperlink or internal <Link> tag and optional caption
 * @param {string} to - The href location of the link
 * @param {string} item - Text to render as hyperlink
 * @param {string} alt - Link alt text
 * @param {boolean} external - specifies an external `<a>` or internal `<Link>` tag
 * @param {string} caption - optional subtext caption
 */

export default function LinkListItem({ to, text, alt, external, caption, linkStyle, elementStyle }) {
  return (
    <li className={elementStyle}>
      {external ? (
        <a href={to} title={alt} target="_blank" rel="noopener noreferrer" style={linkStyle}>
          {text}
        </a>
      ) : (
        <Link to={to} title={alt} style={linkStyle}>
          {text}
        </Link>
      )}
      {caption ? (
        <>
          <br />
          <p className="">{caption}</p>
        </>
      ) : null}
    </li>
  );
}
